export default "__VITE_ASSET__CPJ2B3Yi__"